module.exports = __webpack_public_path__ + "static/media/multicurrencywhatnew.0a2df9d0.mp4";